import { render, staticRenderFns } from "./LatestSubscriber.vue?vue&type=template&id=96715df6"
import script from "./LatestSubscriber.vue?vue&type=script&lang=js"
export * from "./LatestSubscriber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports